<template>
  <div>
    <div style="overflow:hidden;" class="kuang">
      <h4 style="font-size:16px; color:#107BDA; margin:20px 0; font-weight:bold;">会员申请表<p
          style="color:red;float: left;">*</p>
      </h4>
      <span style="color:red">（请下载打印申请表，由所在单位审核盖章后，点击“上传会员申请表”，上传完成后点击“提交入会申请”。）</span>

      <p v-if="sealList.length<=0" style="margin:15px 0;">未上传会员申请表</p>
      <div v-for="item in sealList" :key="item.id" class="imBoxCont">
        <!-- <span v-for="item in sealList" :key="item.id" v-viewer>
          <el-image :src="item.url" class="iner"></el-image>
        </span> -->
        {{ item.name }}
      </div>
    </div>
    <el-dialog title="上传会员申请表（只能上传图片与pdf）" :visible.sync="dialogSeal" width="95%" class="smrz" @close="close()">
      <template>
        <el-upload :action="photoIdUrl" accept=".pdf,.jpeg,.jpg,.png" :on-success="handleSuccessSeal"
          :beforeUpload="beforeAvatarUploadPdf" :class="{ disUoloadSty: noneBtnDealImg }"
          :on-remove="handleRemoveImgSeal" :limit="1" :file-list="sealList"
            :headers="getUploadHeaders()">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button :disabled="loading" type="primary" @click="subSealPhoto">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {
    getFileIdDetails,
    printingSeal,
    saveSingleSeal,
    registerFileDelete,
  } from "@/api/dictionary"
  import { fileuploadUrl } from "@/api/upload"
  import { Toast } from "vant";
  export default {
    data() {
      return {
        sealList: [],
        uploadIds: [],
        noneBtnDealImg: false,
        dialogSeal: false,
        loading: false,
        photoIdUrl: fileuploadUrl,
        filelist: []
      }
    },
    components: { [Toast.name]: Toast },
    props: {
      member: {
        type: Object,
        default: () => { },
      },
    },
    methods: {
      showZl() {
        this.dialogSeal = true
      },
      close() {
        this.dialogSeal = false
        this.filelist = []
      },
      getSeal(id) {
        if (id)
          // getPZUrl({ id }).then((res) => {
          //   if (res.success) {
          getFileIdDetails({ id }).then((resp) => {
            console.log("jj", resp)
            if (resp.success) {
              this.sealList.push({
                // url: res.result,
                name: resp.result.fileName,
                id: id,
              })
              // this.sealList[0].name = resp.result.fileName
            }
          })
        // this.sealList.push({ url: res.result, name: "", id: id })
        //   }
        // })
      },
      handleRemoveImgSeal(file, sealList) {
        this.noneBtnDealImg = sealList.length >= this.limitCount
        registerFileDelete({ id: file.id }).then((res) => {
          if (res.success) {
            this.sealList = []
            let newObject = ""
            this.$emit("changeData", newObject)
          }
        })
        for (let i = 0; i < this.uploadIds.length; i++) {
          if (file.id == this.uploadIds[i]) {
            this.uploadIds.splice(i, 1)
          }
        }
      },
      beforeAvatarUploadPdf(file) {
        this.loading = true
        if (file.type == '') {
          Toast.fail("上传文件后缀名不正确!");
          return false
        }
        let arr = ['.jpeg', '.jpg', '.png', '.pdf']
        const fileType = file.name.substring(file.name.lastIndexOf("."));
        if (arr.indexOf(fileType) == -1) {
          Toast.fail("上传文件类型不正确!");
          return false
        }
        if (file.size / 1024 > 1024 * 20) {
          Toast.fail("上传文件大小不能超过 20M!");
          return false
        }

      },
      handleSuccessSeal(res, file, sealList) {
        this.loading = false
        this.uploadId = res.result.id
        file.id = res.result.id
        this.uploadIds.push(res.result.id)
        this.filelist = sealList
        // this.noneBtnDealImg = sealList.length >= this.limitCount
      },
      subSealPhoto() {
        let ids = this.uploadIds.join(",")
        let params = { seal: ids, id: sessionStorage.getItem("memberId") }
        if (!ids) {
          Toast.fail("请上传盖章材料")
          return
        }
        if (this.member.memberCategory == 1) {
          saveSingleSeal(params).then((res) => {
            if (res.success) {
              Toast.success("完成上传！")
              if (res.result && res.result.seal) {
                this.uploadIds = []
                this.uploadIds = res.result.seal.split(",")
              }
              this.sealList = this.filelist
              this.noneBtnDealImg = this.filelist.length >= this.limitCount
              this.dialogSeal = false
              this.member.seal = ids

            } else {
              Toast.fail(res.message)
            }
          })
        } else {
          printingSeal(params).then((res) => {
            if (res.success) {
              this.$message.success("完成上传！")
              if (res.result && res.result.seal) {
                this.uploadIds = []
                this.uploadIds = res.result.seal.split(",")
              }
              this.dialogSeal = false
              this.member.seal = ids
              // this.reload()
            } else {
              Toast.fail(res.message)
            }
          })
        }
      },
    },
    mounted: function () {
      /*加载盖章资料 */
      if (this.member.seal) {
        // this.uploadIds = this.member.seal.split(",")
        // for (let j = 0; j < this.uploadIds.length; j++) {
        this.getSeal(this.member.seal)
        // }
        this.noneBtnDealImg = this.uploadIds.length >= this.limitCount
      }
    },
  }
</script>

<style scoped>
  /deep/.el-upload--text {
    width: auto;
  }

  /deep/ .el-dialog__title {
    font-size: 16px;
  }

  .kuang {
    font-size: 14px;
    /* padding: 0 18px 0; */
    color: #323233;
    background: #fff;
    padding: 0 18px 0;
  }

  .kuang>h4 {
    display: flex;
    margin: 25px 0;
    font-size: 15px;
    align-items: center;
    color: #1989fa;
    position: relative;
    padding-left: 10px;
  }

  .kuang>h4::before {
    content: "";
    width: 3px;
    height: 80%;
    display: block;
    left: 0;
    background: #1989fa;
    border-radius: 50px;
    position: absolute;
  }

  .imBoxCont {
    overflow: hidden;
    margin-right: -15px;
    color: rgba(52, 124, 175, 1);
  }

  .imBoxCont span {
    width: 29%;
    height: 100px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    float: left;
    background: #000;
    margin-right: 15px;
  }

  /deep/.el-dialog__footer {
    text-align: center;
  }

  /deep/.el-dialog {
    margin-bottom: 0;
    border-radius: 0;
  }

  /deep/.imBoxCont .el-image__inner,
  /deep/.imBoxCont .el-image {
    max-height: 100% !important;
    width: auto !important;
    height: auto !important;
    cursor: pointer;
    max-width: 100%;
  }
</style>